import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as L from 'leaflet';
import { Route } from '../interfaces/route';
import { StopsService } from '../services/stops.service';
import { ScheduleService } from '../services/schedule.service';
import { GlobalVariables } from '../common/global-variables';

const trainUrl: string = "https://www3.septa.org/api/TrainView/?callback=?";
const transitUrl: string = 'https://www3.septa.org/api/TransitViewAll/?callback=?';

const busRed = '../../../assets/images/map/bus/bus-red.png';
const busYellow = '../../../assets/images/map/bus/bus-yellow.png';
const busBlue = '../../../assets/images/map/bus/bus-blue.png';

@Injectable({
  providedIn: 'root'
})
export class MarkersService {

  data: any[] = [];
  routes: Route[] = [];
  test: any = [];
  markers: any = {};
  schedule: string = "";

  constructor(private http: HttpClient, private stopsService: StopsService, private scheduleService: ScheduleService) {
    this.schedule = this.scheduleService.release_date;
    this.scheduleService.get_release_date().subscribe((res: any) => {
        this.schedule = res + "_";
    });
   }

  fetch(map: L.map, route: Route, trip: string = null) {

    if (route.mode == 'Regional Rail') {
      this.getTrains(map, route, trip);
    }
    else {
      this.getTranist(map, route, trip);
    }
  }

  getTrains(map: L.map, route: Route, trip: string = null) {
    return this.http.jsonp(trainUrl, 'callback').subscribe((res: any) => {
      for (const data of res) {
        const combined = this.gcCheck(route.name.replace('/', ' '), data.line.replace('/', ' '));
        if (route.name.replace('/', ' ') == data.line.replace('/', ' ') || combined) {
          const lat = data.lat;
          const lon = data.lon;
          const id = 'r_' + data.trainno;
          const status = data.late == 0 ? GlobalVariables.onTimeStatus : data.late > 0 ? data.late + " " + GlobalVariables.lateStatus : (data.late * -1) + ' ' + GlobalVariables.earlyStatus;
          const pop = '' +
            '<div><strong>Route:</strong> ' + data.line.replace('/', ' ') + '</div>' +
            '<div><strong>Train:</strong> <a href="/trip/detail/' + data.trainno + '">' + data.trainno + '</a></div>' +
            '<div><strong>Consist:</strong> ' + data.consist + '</div>' +
            '<div><strong>Next Stop:</strong> ' + data.nextstop + '</div>' +
            '<div><strong>Destination:</strong> ' + data.dest + '</div>' +
            '<div><strong>Delay:</strong> ' + status + '</div>';
          const exist = this.moveMarker(map, [lat, lon,], id, pop, data, route);

          // Does this route exist in the markers?
          if (trip != null) {
            if (trip == data.trainno) {
              this.createMarker(map, [lat, lon], id, pop, data, route);
            }
          }
          else if (!exist) {
            this.createMarker(map, [lat, lon], id, pop, data, route);
          }
        }
      }
    });
  }

  getTranist(map: L.map, route: Route, trip: string = null) {
    return this.http.jsonp(transitUrl, 'callback').subscribe((res: any) => {
      for (const gps of res.routes) {
        for (const route_id of Object.keys(gps)) {
          if (route.name == route_id || (route.name == "LUCY" && (route_id == "LUCYGR" || route_id == "LUCYGO"))) {
            for (const data of gps[route_id]) {
              const lat = data.lat;
              const lon = data.lng;
              const id = data.VehicleID != 0 ? 't_' + data.VehicleID : 'tb_' + data.BlockID;
              var status = data.late == 0 ? GlobalVariables.onTimeStatus : data.late > 0 ? data.late + " " + GlobalVariables.lateStatus : (data.late * -1) + ' ' + GlobalVariables.earlyStatus;
              var next_stop_name = data.next_stop_name;

              var seat_estimate = '<span class="badge badge-secondary">No Estimate</span>';
              var many_seats = "MANY_SEATS_AVAILABLE";
              var few_seats = "FEW_SEATS_AVAILABLE";
              var standing_seats = "STANDING_ROOM_ONLY";

              if (data.estimated_seat_availability == many_seats) {
                seat_estimate = '<span style="color:#1170aa">Many Seats</span>';
                seat_estimate = '<span class="badge badge-success">Many Seats</span>';
              }
              if (data.estimated_seat_availability == few_seats) {
                seat_estimate = '<span style="color:#ce6c1b">Few Seats</span>';
                seat_estimate = '<span class="badge badge-warning">Few Seats</span>';
              }
              if (data.estimated_seat_availability == standing_seats) {
                seat_estimate = '<span style="color:#c85200">Standing room only</span>';
                seat_estimate = '<span class="badge badge-danger">Standing room only</span>';
              }

              if (!next_stop_name) {
                next_stop_name = 'n/a';
              }
              status = data.late == 998 ? 'Untracked' : data.late > 998 ? 'Canceled' : status;

              var updated_seconds = (Math.ceil((Date.now() / 1000)) - data.timestamp)
              
              if(updated_seconds > 6000) {
                updated_seconds = 600;
              }

              const pop = '' +
                '<div><strong>Route:</strong> ' + route_id + '</div>' +
                '<div><strong>Block:</strong> ' + data.BlockID + '</div>' +
                '<div><strong>Trip:</strong> <a href="/schedule/trip/' + this.schedule + data.trip + '">' + data.trip + '</a></div>' +
                '<div><strong>Vehicle:</strong> ' + data.VehicleID + '</div>' +
                '<div><strong>Direction:</strong> ' + data.Direction + '</div>' +
                '<div><strong>Destination:</strong> ' + data.destination + '</div>' +
                '<div><strong>Next Stop:</strong> ' + next_stop_name + '</div>' +
                '<div><strong>Delay:</strong> ' + status + '</div>' +
                '<div><strong>Estimated Seats:</strong> ' + seat_estimate + '</div>' +
                '<div><strong>Updated:</strong> ' + updated_seconds + ' seconds ago</div>';

              if (data.late !== 9999) {
                const exist = this.moveMarker(map, [lat, lon,], id, pop, data, route);

                // Does this route exist in the markers?
                // Does this route exist in the markers?
                if (trip != null) {
                  if (trip == data.trip) {
                    this.createMarker(map, [lat, lon], id, pop, data, route);
                  }
                }
                else if (!exist) {
                  this.createMarker(map, [lat, lon], id, pop, data, route);
                }
              }
            }
          }
        }
      }
    });
  }

  public addStopMarkers(map: any, selected_route: string, selected_direction: number, selected_stop: number) {

    this.stopsService.getStops(selected_route, selected_direction)
      .subscribe(data => {

        var schedule = data;

        //If stop is selected show stop on map
        for (const d of schedule) {

          var selected = false;

          if (d.stop_id == selected_stop) {
            selected = true;

            var marker = L.marker([d.stop_lat, d.stop_lon], { icon: this.createStopIcon(selected) }).addTo(map)
              .bindPopup('<b>' + d.stop_name + '<br>')
              .openPopup();

            var latLngs = [marker.getLatLng()];
            var markerBounds = L.latLngBounds(latLngs);
            map.fitBounds(markerBounds);
          }
          else {

            var marker = L.marker([d.stop_lat, d.stop_lon], { icon: this.createStopIcon(selected) }).addTo(map)
              .setZIndexOffset(-50)
              .bindPopup('<b>' + d.stop_name + '<br/><br/>' + '<center><a class="btn btn-outline-info btn-sm" href="/schedules/' + selected_route + '/' + selected_direction + '/' + d.stop_id + '">Select</a></center>')
            //.on('click', this.router.navigateByUrl('schedules/' + this.id + '/' + this.selected_direction + '/' + d.stop_id));
          }

          marker.options._markertype = 'stop';
        }
      });
  }

  //Remove all markers for type vehicle
  public clearMarkers(map: L.map) {
    if (map != undefined) {
      map.eachLayer(function (layer: any) {
        if (layer.options._markertype == 'vehicle') {
          map.removeLayer(layer);
          return true;
        }
      });
    }
  }

  //Remove all markers for type stop
  public clearStopMarkers(map: L.map) {
    map.eachLayer(function (layer: any) {
      if (layer.options._markertype == 'stop') {
        map.removeLayer(layer);
        return true;
      }
    });
  }

  private createMarker(map: L.map, geo: any, id: string, pop: string, data: any, route: Route): void {
    var marker = L.marker(geo, { icon: this.createIcon(data, route) })
    marker._leaflet_id = id;
    marker.options._markertype = 'vehicle';
    marker.addTo(map);
    marker.bindPopup(pop);

  }

  //Take a marker, check if it exists, move it, if not create it.
  private moveMarker(map: L.map, geo: any, id: string, pop: string, data: any, route: Route): boolean {
    var exist = false;
    var icon = this.createIcon(data, route);
    map.eachLayer(function (layer: any) {
      if (layer._leaflet_id === id && layer.options._markertype == 'vehicle') {

        layer.setLatLng(geo);
        layer.setIcon(icon);
        layer.bindPopup(pop);
        exist = true;
        return true;
      }
    });
    return exist;
  }

  private gcCheck(combined: string, route: string) {
    if (combined == 'Glenside Combined' && (route == 'Lansdale Doylestown' || route == 'Warminster' || route == 'West Trenton')) {
      return true
    }
    return false;
  }

  // Creates the correct icon for the marker.
  private createIcon(data: any, route: any) {

    var iconUrl = '';
    var angle = data.heading + 180;
    var circleArrow = '<path class="st0" d="M1.7,69.3c0,22.2,10.7,41.9,27.3,54.1c0.2,0.3,36.6,41.8,36.6,41.8c1.9,1.9,5.1,1.9,7,0 		c0,0,36.4-41.5,36.6-41.8c16.5-12.3,27.3-32,27.3-54.1c0-37.2-30.2-67.4-67.4-67.4S1.7,32.1,1.7,69.3z" transform="rotate(' + angle + ' 68.8 69.1)"/>';

    var iconColor = '';

    var iconOld;
    if ((data.Direction == 'EastBound') || (data.Direction == 'NorthBound')) {
      iconColor = '00539F'; //blue
      iconOld = busBlue;
    } else if ((data.Direction == 'WestBound') || (data.Direction == 'SouthBound')) {
      iconColor = 'EA0029'; //red
      iconOld = busRed;
    } else {
      iconColor = 'F6891F'; //orange
      iconOld = busYellow;
    }

    if (route.mode == "Bus") {
      iconUrl = 'data:image/svg+xml;utf-8, <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  width="40" height="46" viewBox="-30 0 199.8 169.8" xml:space="preserve">  <style type="text/css"> 	.st0{fill:%23' + iconColor + ';} 	.st1{fill:%23FFFFFF;stroke:%23' + iconColor + ';stroke-width:4.6757;stroke-miterlimit:10;} 	.st2{fill:%23414042;} </style> <g> ' + circleArrow + '<circle class="st1" cx="68.8" cy="69.1" r="63"/> </g> <path class="st2" d="M102.3,91.8l1.2-10.3l-1.8-43.8c0-2.5-1.2-11-5-11.4H42.5c-4.6,0.1-5.7,8.5-5.4,11.4l-2.7,45l1.3,9.1 		c-0.9,0.3-1.5,1.1-1.5,2.2v4.2c0,1.3,1,2.3,2.2,2.3h6.5v5.8c0,1.2,1,2.2,2.2,2.2h4.8c1.2,0,2.2-1,2.2-2.2v-5.8h35.5v5.6 		c0,1.2,1,2.2,2.2,2.2h4.8c1.2,0,2.2-1,2.2-2.2v-5.6h5.4c1.2,0,2.2-1,2.2-2.3V94C104.1,92.9,103.3,92,102.3,91.8 M44.2,31.2 		c0-0.7,1.2-1.5,1.8-1.5h46.3c0.6,0,1.2,0.6,1.2,1.2l0.7,6.6c0,0.7-1.2,1.3-1.9,1.3H44.6c-0.7,0-1.2-0.5-1.2-1.2L44.2,31.2z 		M47.7,89.4c0,0.6-0.3,1.2-0.6,1.2H42c-0.3,0-0.6-0.5-0.6-1.2V87c0-0.6,0.3-1.2,0.6-1.2h5.1c0.3,0,0.6,0.5,0.6,1.2 		C47.7,87,47.7,89.4,47.7,89.4z M56.6,89.4c0,0.6-0.3,1.2-0.6,1.2h-5.1c-0.3,0-0.6-0.5-0.6-1.2V87c0-0.6,0.3-1.2,0.6-1.2H56 		c0.3,0,0.6,0.5,0.6,1.2V89.4z M88.9,89.4c0,0.6-0.3,1.2-0.6,1.2h-5.1c-0.3,0-0.6-0.5-0.6-1.2V87c0-0.6,0.3-1.2,0.6-1.2h5.1 		c0.3,0,0.6,0.5,0.6,1.2V89.4z M97.8,89.4c0,0.6-0.3,1.2-0.6,1.2h-5.1c-0.3,0-0.6-0.5-0.6-1.2V87c0-0.6,0.3-1.2,0.6-1.2h5.1 		c0.3,0,0.6,0.5,0.6,1.2V89.4z M94,75.3H44.3c-1.8,0-4.9-1.5-4.9-3.5l1-25.2c0-2,2-3.7,3.9-3.7H94c1.8,0,3.3,1.6,3.3,3.6L98.1,72 		C98.1,74,95.8,75.3,94,75.3"/> </svg>';
    }
    else if (route.mode == "Trolley") {
      iconUrl = 'data:image/svg+xml;utf-8, <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  width="40" height="46" viewBox="-30 0 199.8 169.8" xml:space="preserve">  <style type="text/css"> 	.st0{fill:%23' + iconColor + ';} 	.st1{fill:%23FFFFFF;stroke:%23' + iconColor + ';stroke-width:4.6757;stroke-miterlimit:10;} 	.st2{fill:%23414042;} </style> <g> ' + circleArrow + '<circle class="st1" cx="68.8" cy="69.1" r="63"/> </g> <g> 	<path class="st2" d="M42.8,94.6h6.4V84.2h39.4v10.4h5.7c0,0,0.7-24.6,0.8-26c0.1-1.4-0.1-4.4-0.1-5c0-0.6-4.3-29-4.6-30.8 		c-0.3-1.9-2.7-2.8-4.2-2.8H71.5v-5.9l1-1v-2.8h-3.8h-4.1v2.8l1,1v5.9H51c-1.5,0-3.8,0.9-4.2,2.8c-0.3,1.9-4.6,30.3-4.6,30.8 		c0,0.6-0.2,3.6-0.1,5C42.2,70.1,42.8,94.6,42.8,94.6z M52.6,81.2c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 		c1.3,0,2.4,1.1,2.4,2.4C55.1,80.1,54,81.2,52.6,81.2z M52.6,75c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4 		c1.3,0,2.4,1.1,2.4,2.4C55.1,73.9,54,75,52.6,75z M84.9,81.3c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4 		C87.3,80.2,86.3,81.3,84.9,81.3z M84.9,75.1c-1.3,0-2.4-1.1-2.4-2.4c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4 		C87.3,74,86.3,75.1,84.9,75.1z M53.1,37.3c0.5-1.8,2-2.3,3.8-2.3h12h12c1.8,0,3.2,0.5,3.8,2.3c0.1,0.4,0.3,0.7,0.6,3H52.6 		C52.9,38,53,37.7,53.1,37.3z M52.5,43.5h32.9c0.9,7.1,2.2,19.7,2.2,20.2c0,0.8-0.2,2.4-3,2.4c-2.8,0-15.8,0-15.8,0s-13,0-15.8,0 		c-2.8,0-3-1.6-3-2.4C50.1,63.1,51.6,50.6,52.5,43.5z"/> 	<polygon class="st2" points="91.3,102.4 86.5,102.4 93,111.4 99.6,111.4 	"/> 	<polygon class="st2" points="37.8,111.4 44.4,111.4 50.9,102.4 46.1,102.4 	"/> 	<polygon class="st2" points="87,101.9 87,97 87,95.1 87,86.1 50.8,86.1 50.8,95.1 50.8,97 50.8,101.9 55.5,101.9 55.5,97 82.4,97  		82.4,101.9 	"/> </g></svg>';
    }
    else if (route.mode == "Regional Rail") {
      switch (route.name) {
        case 'Warminster':
          iconColor = "F7AF42";
          break;
        case 'Cynwyd':
          iconColor = "6F549E";
          break;
        case 'West Trenton':
          iconColor = "5D5EBC";
          break;
        case 'Fox Chase':
          iconColor = "FF823D";
          break;
        case 'Lansdale Doylestown':
          iconColor = "775B49";
          break;
        case 'Chestnut Hill West':
          iconColor = "00B4B2";
          break;
        case 'Chestnut Hill East':
          iconColor = "94763C";
          break;
        case 'Media Elwyn':
          iconColor = "007CC8";
          break;
        case 'Manayunk Norristown':
          iconColor = "EE4C69";
          break;
        case 'Wilmington Newark':
          iconColor = "8AD16B";
          break;
        case 'Trenton':
          iconColor = "F683C9";
          break;
        case 'Paoli Thorndale':
          iconColor = "20825C";
          break;
        case 'Airport':
          iconColor = "91456C";
          break;
        default:
          iconColor = "00539F";
      }
      iconUrl = 'data:image/svg+xml;utf-8, <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  width="40" height="46" viewBox="-30 0 199.8 169.8" xml:space="preserve">  <style type="text/css">   .st0{fill:%23' + iconColor + ';}  .st1{fill:%23FFFFFF;stroke:%23' + iconColor + ';stroke-width:4.6757;stroke-miterlimit:10;}  .st2{fill:%23414042;} </style> <g> ' + circleArrow + '<circle class="st1" cx="68.8" cy="69.1" r="63"/> </g> <g> <path class="st2" d="M88.3,91.1v-2.3h2.2l5.1-11.1v-33H41.1v33l5.1,11h2.4V91h3.8v-3.9h1.9l2.5-4.1v-4h3.3l0.2-29.7    c0.1-1,0.6-0.9,2.2-1c0.2,0,4,0,11.5,0c1.7,0,2.4-0.2,2.4,1.3V79h3.3v4l2.6,4.1h2.1V91L88.3,91.1L88.3,91.1z M47.3,59.9    c-0.5,0-0.8-0.5-0.8-0.9V49c0-0.4,0.4-0.6,0.8-0.6h8.1c0.4,0,0.8,0.2,0.8,0.6v9.9c0,0.5-0.3,0.9-0.8,0.9L47.3,59.9L47.3,59.9z    M54.4,73.2c-1.4,0-2.6-1.2-2.6-2.6S53,68,54.4,68s2.6,1.2,2.6,2.6S55.9,73.2,54.4,73.2z M81.8,73.1c-1.4,0-2.6-1.2-2.6-2.6    s1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6C84.5,71.9,83.3,73.1,81.8,73.1z M80.5,60c-0.5,0-0.8-0.5-0.8-0.9v-9.9c0-0.4,0.4-0.6,0.8-0.6h8.1    c0.4,0,0.8,0.2,0.8,0.6V59c0,0.5-0.3,0.9-0.8,0.9L80.5,60L80.5,60z"/>    <path class="st2" d="M93.7,37.7c-3.5-2.2-6.4-2.7-12.4-3.7l-11.8-1v-4.7h1.1v-3.8h-1.1v-2.2l4,0.1c-0.4-0.1,5.2,0.6,7.2,1.9    c0.3,0.2,0.7,0.5,1,0.2c0.1-0.2,1.7-1.9,1.7-1.9c-1.1-1.4-2.7-2.8-3.1-2.9l-6.8-1.1H62.9l-5.6,1.1c-0.2,0-3.1,2.7-3,3.1    c0,0,1.6,2,1.7,2c0,0,0.3-0.1,0.8-0.4c1.9-1,3.8-1.6,5.8-1.7l4.6-0.2v2.2h-1.3v3.8h1.3V33l-13.5,1c-2.4,0.4-7.6,0.7-10.9,3.8    c-1.5,1.4-1.6,5.5-1.7,5.5h54.5C95.7,43.3,95.5,38.8,93.7,37.7z M56.8,41.7h-9.3c0,0,0-1.1,0-2.1c0-0.9,0-1.1,0.9-1.4    c4.8-1.6,5.9-1.2,7.3-1.3c0.7,0,1.1,0.2,1.3,0.6L56.8,41.7z M76.8,39.6c0,1.2-1,2.2-2.2,2.2H62.4c-1.2,0-2.2-1-2.2-2.2v-1    c0-1.2,1-2.2,2.2-2.2h12.2c1.2,0,2.2,1,2.2,2.2C76.8,38.6,76.8,39.6,76.8,39.6z M89.3,41.7h-9.4v-4.1c0.1-0.4,0.6-0.6,1.3-0.6    c1.3,0,2.4-0.3,7.3,1.3c0.9,0.3,0.9,0.5,0.9,1.4C89.4,40.6,89.3,41.7,89.3,41.7z"/>    <path class="st2" d="M71,61c1.2,0,2.2-1,2.2-2.2v-6.5c0-1.2-1-2.2-2.2-2.2h-6c-1.2,0-2.2,1-2.2,2.2v6.5c0,1.2,1,2.2,2.2,2.2H71z"/>    <rect x="57.9" y="80.1" class="st2" width="20.7" height="4.1"/>    <path class="st2" d="M63.4,37.3c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7S64.4,37.3,63.4,37.3z"/>    <path class="st2" d="M73.7,37.4c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7C75.4,38.1,74.7,37.4,73.7,37.4z"/>    <path class="st2" d="M100.5,108.1l-3.3-5.5h-3.3l-1.7-2.9h3.3L92.6,95h-3.1l-0.9-1.5H84l0.8,1.5H52.4l0.8-1.5h-4.7L47.7,95h-3.1    l-2.8,4.7H45l-1.7,2.9H40l-3.3,5.5h3.6l-3,5.2h8.5l2.4-5.2H89l2.4,5.2h8.5l-3-5.2H100.5z M49.3,102.6l1.3-2.9h35.9l1.3,2.9H49.3z"/>    </g></svg>';
    }

    var icon = L.icon({
      iconUrl: iconUrl,
      iconAnchor: [20, 23],
    });

    return icon;
  }

  public createStopIcon(selected: boolean) {

    var stroke: string = "rgb(51, 136, 255)"
    var iconUrl: string = 'data:image/svg+xml;utf-8, <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  width="40" height="40" viewBox="-30 0 199.8 169.8" xml:space="preserve"> <circle class="st1" cx="68.8" cy="69.1" r="63" stroke="black" stroke-width="20" fill="' + stroke + '"/></svg>'

    if (selected) {
      var iconUrl: string = 'data:image/svg+xml;utf-8, <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  width="40" height="40" viewBox="-30 0 199.8 169.8" xml:space="preserve"> <circle class="st1" cx="68.8" cy="69.1" r="63" stroke="' + stroke + '" stroke-width="20" fill="black"/></svg>'
    }

    var icon = L.icon({
      iconUrl: iconUrl,
      iconSize: [40, 40],
      iconAnchor: [20, 20]
    });

    return icon;
  }

}

